import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { take } from 'rxjs/operators';
import * as _ from 'lodash';

export abstract class HttpServiceBase {

    public readonly host: string;

    protected abstract http: HttpClient;
    protected readonly apiServer: string;

    private httpOptions = {
        headers: new HttpHeaders({
            'content-type': 'application/json'
        })
    };


    protected constructor(apiServer: string) {
        this.apiServer = apiServer;
        this.host = environment.hosts[this.apiServer];
    }

    public get<T>(path: string, options?): Observable<T> {
        return this.http.get(this.url(path), this.setOptions(options)).pipe(take(1)) as any as Observable<T>;
    }

    public post<T>(path: string, body: any, options?): Observable<T> {
        return this.http.post(this.url(path), body, this.setOptions(options)).pipe(take(1)) as any as Observable<T>;
    }

    public delete<T>(path: string, options?): Observable<T> {
        return this.http.delete(this.url(path), this.setOptions(options)).pipe(take(1)) as any as Observable<T>;
    }

    public put<T>(path: string, body: any, options?): Observable<T> {
        return this.http.put(
            this.url(path),
            body,
            this.setOptions(options))
            .pipe(take(1)) as any as Observable<T>;
    }

    private setOptions(options: any) {
        if (!options) {
            return this.httpOptions;
        }

        const newOptions = _.extend(options, this.httpOptions);

        return _.cloneDeep(newOptions);
    }

    private url(path: string): string {
        return `${this.host}${path}`;
    }
}
